import React, { Component } from 'react';
import { ConsultCuentaAdminHist } from "../../../funciones/EstCuentaFunction";

class EstCuentaTable extends Component {
    state = {
        boton1: {
            icon: "fa fa-money",
            text: "Cuenta",
            disabled: false
        },
    }

    verDetalles = (datos) => {
        if (this.state.boton1.disabled === true) return null;

        this.setState({
            boton1: {
                icon: "fa fa-spinner fa-spin",
                text: "Espera",
                disabled: true
            }
        }, () => {
            ConsultCuentaAdminHist (datos.id, (resp)=> {
                this.props.Detalles([resp[0], datos, resp[1]])
                this.setState({
                    boton1: {
                        icon: "fa fa-money",
                        text: "Cuenta",
                        disabled: false
                    }
                })
            })
        })
    }

    render() {
        let { datos } = this.props;
        let { boton1 } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        const styles2 = {
            padding: 5, fontSize: 11
        }

        let icono = () => {
            let text = "text-danger fa fa-times-circle"
            if (datos.Status === true) text = "text-success fa fa-check-circle";
            return text;
        }

        return (
            <React.Fragment>
                <tr>
                    <td style={styles}>
                        <strong>{datos.Ci}</strong> - { datos.Estudiante}
                    </td>
                    <td align="center" style={styles2}>{datos.Carrera}</td>
                    <td align="center" style={styles}><i className={icono()}></i> {datos.Deuda}</td>
                    <td align="center" style={styles}>
                        <button className="btn btn-primary" onClick={()=> {this.verDetalles(datos)}} title= "Haz click aqui para ver el Estado de Cuenta" style={{borderWidth: 1}}><i className={boton1.icon}></i> {boton1.text}</button>
                    </td>
                </tr>
            </React.Fragment>);
    }
}
 
export default EstCuentaTable;


// WEBPACK FOOTER //
// ./src/views/Administracion/EstadosCuentaContent/EstCuentaTable.jsx